import { computed, ref, unref } from 'vue'
import { buildProp } from '@vuesax-plus/utils'
import { componentSizes } from '@vuesax-plus/constants'
import { useProp } from '../use-prop'
import type { ComponentSize } from '@vuesax-plus/constants'
import type { MaybeRef } from '@vueuse/core'

export const useSizeProp = buildProp({
  type: String,
  values: componentSizes,
  required: false,
} as const)

export const useSize = (
  fallback?: MaybeRef<ComponentSize | undefined>,
  ignore: Partial<Record<'prop' | 'global', boolean>> = {}
) => {
  const emptyRef = ref(undefined)

  const size = ignore.prop ? emptyRef : useProp<ComponentSize>('size')

  return computed(
    (): ComponentSize =>
      size.value || unref(fallback) || ''
  )
}

export const useDisabled = (fallback?: MaybeRef<boolean | undefined>) => {
  const disabled = useProp<boolean>('disabled')
  return computed(() => disabled.value || unref(fallback) || false)
}
